
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindTurbineOcean as ObiWindTurbineOceanElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-turbine-ocean.js';
 
 
 

 
 export const ObiWindTurbineOcean = createComponent({
   react: React,
   tagName: 'obi-wind-turbine-ocean',
   elementClass: ObiWindTurbineOceanElement,
   events: {
     
   }
  });
 
 